module.exports = __webpack_public_path__ + "img/9835de7.webp";